class HeaderInlineMenuA11y extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const menuRoot = document.querySelector('.header__inline-menu');
    if (!menuRoot) return;

    const detailsElements = menuRoot.querySelectorAll('details');

    detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const menuItems = details.querySelectorAll('.mega-menu__link');
      if (!summary) return;

      summary.addEventListener('focus', () => {
        details.setAttribute('open', '');
      });

      summary.addEventListener('blur', () => {
        window.setTimeout(() => {
          if (!details.contains(document.activeElement)) {
            details.removeAttribute('open');
          }
        }, 100);
      });

      menuItems.forEach((item) => {
        item.addEventListener('blur', () => {
          window.setTimeout(() => {
            if (!details.contains(document.activeElement)) {
              details.removeAttribute('open');
            }
          }, 100);
        });
      });
    });

    if (window.__headerInlineMenuTabBound) return;
    window.__headerInlineMenuTabBound = true;

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;

      const focusedElement = document.activeElement;
      if (focusedElement?.tagName.toLowerCase() !== 'summary') return;

      const details = focusedElement.closest('details');
      if (details?.closest('.header__inline-menu') && !details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });
  }
}

customElements.define('header-inline-menu-a11y', HeaderInlineMenuA11y);
